<div class="color-trigger" [style.background]="_value" (click)="op.toggle($event)">
</div>

<p-popover #op>
    @if (mode === 'preset')
    {
    <div class="preset-grid">

        @for (c of presetColors; track c)
        {
        <div class="preset-color" [style.background]="c" (click)="selectPreset(c)">
        </div>
        }

    </div>

    <button pButton type="button" label="Erweitert..." (click)="mode='advanced'">
    </button>
    }

    @if (mode === 'advanced')
    {
    <color-sketch [color]="_value" (onChangeComplete)="colorChanged($event)">
    </color-sketch>

    <button pButton type="button" label="Vordefinierte Farben" (click)="mode='preset'">
    </button>
    }
</p-popover>